var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { itemscope: "", itemtype: "http://schema.org/Thing" } },
    [
      [
        _c(
          "div",
          {
            ref: "single",
            staticClass:
              "single-carousel owl-carousel owl-theme owl-single-item mt-0"
          },
          _vm._l(_vm.singleImages, function(image, index) {
            return _c(
              "div",
              {
                staticClass: "prop-1-1",
                class: { video: image.isVideo },
                attrs: { "data-index": index }
              },
              [
                !image.isVideo
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: image.url,
                          "data-lightbox": "single-item-image" + _vm._uid
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "owl-lazy",
                          attrs: {
                            "data-src": image.url,
                            alt: _vm.getAltText(image),
                            title: _vm.getImageName(image)
                          }
                        })
                      ]
                    )
                  : [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.videoPlaying,
                              expression: "!videoPlaying"
                            }
                          ],
                          staticClass: "single__video-play",
                          on: {
                            click: function($event) {
                              return _vm.videoPlay()
                            }
                          }
                        },
                        [
                          _c("svg", [
                            _c("use", { attrs: { "xlink:href": "#play" } })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "video-wrapper",
                          class: { playing: _vm.videoPlaying }
                        },
                        [
                          _c("video", {
                            ref: "video",
                            refInFor: true,
                            staticClass: "single__video-player",
                            attrs: {
                              playsinline: "",
                              muted: "",
                              loop: "",
                              preload: "none",
                              src: image.url.replace("http:", "https:"),
                              poster: _vm.replacePoster(
                                image.url.replace("http:", "https:")
                              )
                            },
                            domProps: { muted: true },
                            on: {
                              click: function($event) {
                                return _vm.videoPause()
                              }
                            }
                          })
                        ]
                      )
                    ]
              ],
              2
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.showThumbs
          ? _c(
              "div",
              {
                ref: "thumbs",
                staticClass:
                  "owl-thumbs owl-carousel owl-theme owl-single-item",
                attrs: { id: "thumb-carousel" }
              },
              _vm._l(_vm.carouselImages, function(imagePreview, index) {
                return _c(
                  "div",
                  {
                    staticClass: "prop-1-1",
                    class: { "item-active": _vm.currentItem == index }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "image-container",
                        on: {
                          click: function($event) {
                            return _vm.goTo(index)
                          }
                        }
                      },
                      [
                        !imagePreview.isVideo
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "owl-thumb border-appearance",
                                "image-url": imagePreview.url,
                                alt: _vm.getAltText(imagePreview),
                                title: _vm.getImageName(imagePreview)
                              }
                            })
                          : [
                              _c("svg", [
                                _c("use", { attrs: { "xlink:href": "#play" } })
                              ]),
                              _vm._v(" "),
                              _c("lazy-img", {
                                attrs: {
                                  "picture-class":
                                    "owl-thumb border-appearance",
                                  "image-url": _vm.replacePoster(
                                    imagePreview.url.replace("http:", "https:")
                                  ),
                                  alt: "video",
                                  title: "video"
                                }
                              })
                            ]
                      ],
                      2
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ],
      _vm._v(" "),
      !_vm.initialized
        ? _c(
            "div",
            {
              staticClass:
                "single-carousel owl-carousel owl-loaded owl-theme owl-single-item mt-0"
            },
            [
              _c("div", { staticClass: "prop-1-1" }, [
                _c("img", {
                  staticClass: "owl-placeholder",
                  attrs: {
                    src: _vm.singleImages[0].url,
                    alt: _vm.getAltText(_vm.singleImages[0].url),
                    title: _vm.getImageName(_vm.singleImages[0].url)
                  }
                })
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }